import { render, staticRenderFns } from "./ClientsList.vue?vue&type=template&id=895e8f88&scoped=true"
import script from "./ClientsList.vue?vue&type=script&lang=js"
export * from "./ClientsList.vue?vue&type=script&lang=js"
import style0 from "./ClientsList.vue?vue&type=style&index=0&id=895e8f88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "895e8f88",
  null
  
)

export default component.exports